import React, { Component } from "react";
import { Button, Form, Modal, Row, Popconfirm, Input } from "antd";
import CloseIcon from "../../../assets/fi_x-circle.svg";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { setkeyboardEnabled } from "../../../actions/AppAction";
import { sendShareAssets } from "../../../actions/AssetsShareAction";
import { sendNotification } from "../../../utils/index";
import { deleteFolder } from "../../../actions/ClientAction";
import { cleanDataBackRoot, getRoot } from "../../../actions/AssetsRootAction";
import { getExplore } from "../../../actions/AssetsExploreAction";
import { getLastUploads } from "../../../actions/AssetsLastUploadAction";
import { getFavorites } from "../../../actions/AssetsFavoritesAction";
import { getShared } from "../../../actions/AssetsShareAction";
import fileextension from "file-extension";
import SVGView from "../../assets-view/SVGView";
import { VideoView } from "../../assets-view/VideoView";
import DocumentView from "../../document-view/DocumentView";
import WarningIcon from "../../../assets/icons/warning-icon.svg";
import { deleteSelectedAsset } from "../../../actions/ClientAction";
import { getBreadCrumbs, canDeleteAsset } from "../../../utils";
import "./DeleteModal.css";

class DeleteModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      folderId: props.selectedFile._id,
      breadCrumbs: []
    };
  }

  componentDidMount() {
    this.handleGetPathItem();
    const isFolder =
      this.props.selectedFile.type === "bunker" ||
      this.props.selectedFile.type === "folder";
    if (isFolder) {
      this.handleFolderSelect(this.props.selectedFile._id);
    }
    this.props.setkeyboardEnabled(true);
  }

  handleOnDelete = () => {
    const {
      workclient,
      selectedFile,
      keyCollection,
      intl,
      user,
      newMatrix
    } = this.props;

    // Este modal se abre desde la búsqueda y desde Explore sin ningún filtro de
    // permisos, y el control que lo cubría quedó comentado más abajo. Sin esto,
    // confirmar borraba igual. El backend además lo valida.
    const isAdmin =
      !!user && (user.clientRole === "admin" || user.role === "admin");
    if (!isAdmin && !canDeleteAsset(selectedFile, newMatrix)) {
      sendNotification(
        "warning",
        intl,
        intl.formatMessage({ id: "permission_denied" })
      );
      this.handleOnHideModal();
      return;
    }

    const isFolderOrBunker =
      selectedFile.type === "folder" || selectedFile.type === "bunker";
    if (isFolderOrBunker) {
      this.props.deleteFolder(
        workclient,
        selectedFile._id,
        selectedFile.name,
        null,
        null,
        this.handleOnHideModal,
        false
      );
    } else {
      this.props.deleteSelectedAsset(
        keyCollection,
        workclient,
        selectedFile._id,
        intl
      );
      this.props.handleHiddenModal();
    }
  };

  handleProcessBreadCrumbs = folderselect => {
    const breadcrumb = getBreadCrumbs(folderselect);
    if (breadcrumb && breadcrumb.length > 0) {
      return breadcrumb
        .filter(r => r.id !== folderselect)
        .map(r => r.name)
        .join("/");
    } else {
      return "";
    }
  };

  handleFolderSelect = folderId => {
    this.setState({
      folderId: folderId,
      breadcrumbState: this.handleProcessBreadCrumbs(folderId)
    });
  };

  handleOnHideModal = () => {
    const { intl, workclient, root, limit, keyCollection } = this.props;
    sendNotification(
      "success",
      intl,
      intl.formatMessage({ id: "delete-modal-success" })
    );
    const location = this.props.history.location.pathname;
    if (!location.includes("explore")) {
      if (keyCollection === "assetsLastUploads") {
        this.props.getLastUploads(workclient, root);
      } else if (keyCollection === "assetsShared") {
        this.props.getShared(workclient, root);
      } else if (keyCollection === "assetsFavorites") {
        this.props.getFavorites(workclient, root);
      } else {
        this.props.cleanDataBackRoot();
        // this.props.getRoot(workclient, root)
        this.props.getRoot(workclient, root, true, [], 1, 40);
      }
      this.props.handleHiddenModal();
      return;
    }
    const folderId = location.split("/").pop();
    if (!folderId) return;
    this.props.handleHiddenModal();
    if (keyCollection === "assetsLastUploads") {
      this.props.getLastUploads(workclient, folderId, 1, null, true, [], limit);
    } else if (keyCollection === "assetsShared") {
      this.props.getShared(workclient, folderId, 1, null, true, [], limit);
    } else if (keyCollection === "assetsFavorites") {
      this.props.getFavorites(workclient, folderId, 1, null, true, [], limit);
    } else {
      this.props.getExplore(workclient, folderId, 1, null, true, [], 40);
    }
  };

  handleGetPathItem = () => {
    const { selectedFile, breadcrumb } = this.props;
    let route = [];
    if (selectedFile.parents) {
      selectedFile.parents.forEach(itemParents => {
        breadcrumb.forEach(breadElement => {
          if (itemParents === breadElement._id) route.push(breadElement.name);
        });
      });
      this.setState({
        breadCrumbs: `/${route.join("/")}`
      });
    }
  };

  render() {
    const {
      showModal,
      handleHiddenModal,
      intl,
      selectedFile,
      isInFolderAction
    } = this.props;

    const { breadCrumbs, breadcrumbState } = this.state;

    const isBunker =
      selectedFile.type === "folder" || selectedFile.type === "bunker";
    const prefix = isBunker ? "" : "_file";

    return (
      <Modal
        visible={showModal}
        onCancel={handleHiddenModal}
        width={500}
        footer={null}
        centered
        closeIcon={<img src={CloseIcon} alt={"icon close"} />}
        className="delete-modal"
      >
        <div className="delete-modal-title">
          {intl.formatMessage({ id: "delete_asset" })}
        </div>

        {/* Asset view */}
        {!isBunker && (
          <div className="delete-modal-fileview-wrapper">
            <div className="delete-modal-view-wrapper">
              {selectedFile.type === "image" &&
                fileextension(selectedFile.originalURL) === "svg" && (
                  <SVGView
                    comFromMiddleView={true}
                    src={selectedFile.originalURL}
                    assetId={selectedFile._id}
                  />
                )}
              {selectedFile.type === "image" &&
                fileextension(selectedFile.originalURL) !== "svg" && (
                  <img
                    alt={selectedFile.name}
                    src={selectedFile.mediaQualityURL}
                    className="delete-modal-img"
                  />
                )}
              {selectedFile.type === "video" && (
                <VideoView
                  url={selectedFile.lowQualityURL}
                  disableDefaultControls={false}
                  autoPlay={false}
                  muted={false}
                  divWidth={300}
                  from="list"
                />
              )}
              {selectedFile.type === "document" && (
                <DocumentView item={selectedFile} from={`middleView`} />
              )}
            </div>
            <div className="delete-modal-file-delete">
              <span>
                ¿{intl.formatMessage({ id: "second_warning_delete" })}{" "}
                <b>{selectedFile.name}</b>?
              </span>
            </div>
            <div
              data-show="true"
              className="ant-alert ant-alert-warning ant-alert-with-description"
              style={{ marginTop: 10 }}
            >
              <i
                aria-label="icon: exclamation-circle"
                className="anticon anticon-exclamation-circle ant-alert-icon"
              >
                <img
                  src={WarningIcon}
                  alt="warn"
                  className="delete-modal-warn-icon"
                />
              </i>
              <span className="ant-alert-message">
                {intl.formatMessage({ id: "warning" })}
              </span>
              <span className="ant-alert-description">
                {intl.formatMessage({ id: "first_warning_delete" })}{" "}
                <b>{breadCrumbs}</b>
              </span>
            </div>
          </div>
        )}
        {/* Folder view */}
        {isBunker && isBunker === true && (
          <div className="delete-modal-fileview-wrapper">
            <Form>
              <Form.Item>
                {/* <Breadcrumb
                  title={intl.formatMessage({
                    id: `delete-modal-label1${prefix}`
                  })}
                  value={selectedFile._id}
                  placeholder={intl.formatMessage({
                    id: "delete_folder_select"
                  })}
                  handleFolderSelect={this.handleFolderSelect}
                  changeFolder={false}
                  permissionAware={
                    user.clientRole === "admin" || user.role === "admin"
                      ? false
                      : true
                  }
                  permissionsArray={["deleteFolder"]}
                /> */}
                <span>
                  {intl.formatMessage({
                    id: `delete-modal-label1${prefix}`
                  })}
                </span>
                <Input type="text" value={selectedFile.name} disabled />
                {breadcrumbState !== "" && (
                  <div
                    data-show="true"
                    className="ant-alert ant-alert-warning ant-alert-with-description"
                    style={{ marginTop: 10 }}
                  >
                    <i
                      aria-label="icon: exclamation-circle"
                      className="anticon anticon-exclamation-circle ant-alert-icon"
                    >
                      <img
                        src={WarningIcon}
                        alt="warn"
                        className="delete-modal-warn-icon"
                      />
                    </i>
                    <span className="ant-alert-message">
                      {intl.formatMessage({ id: "warning" })}
                    </span>
                    <span className="ant-alert-description">
                      {intl.formatMessage({ id: "delete_folder_confirm" })}{" "}
                      <b>{breadcrumbState}</b>
                    </span>
                  </div>
                )}
              </Form.Item>
            </Form>
          </div>
        )}

        <Row type={"flex"} justify={"space-between"}>
          <Popconfirm
            title={intl.formatMessage({
              id: `delete-modal-delete-confirm${prefix}`
            })}
            onConfirm={this.handleOnDelete}
            okText={intl.formatMessage({ id: "delete_asset" })}
            cancelText={intl.formatMessage({ id: "cancel_button" })}
          >
            <Button
              size={"large"}
              type={"primary"}
              loading={isInFolderAction}
              className="delete-modal-button accept"
            >
              {intl.formatMessage({ id: "delete" })}
            </Button>
          </Popconfirm>
          <Button
            size={"large"}
            type={"primary"}
            ghost
            onClick={handleHiddenModal}
            className="delete-modal-button cancel"
          >
            {intl.formatMessage({ id: "cancel_button" })}
          </Button>
        </Row>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedFile: state.individualSelect.selectedFile,
    workclient: state.client.data ? state.client.data._id : null,
    isInFolderAction: state.client.isInFolderAction,
    user: state.authUser.user,
    newMatrix: state.group.newMatrix,
    root: state.client.root,
    limit: state.assetsExplore.limit,
    breadcrumb: state.client.breadcrumb,
    keyCollection: state.individualSelect.keyCollection
  };
};

const mapDispatchToProps = {
  setkeyboardEnabled,
  sendShareAssets,
  getRoot,
  cleanDataBackRoot,
  getExplore,
  getLastUploads,
  getShared,
  getFavorites,
  deleteFolder,
  deleteSelectedAsset
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(DeleteModal))
);
